import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

export default makeStyles({
  frontLayout: {
    '&': tw`grid grid-cols-5 gap-4
    rounded-xl items-center relative
    bg-white z-10 p-4`,
    // minWidth: '388px',
    minHeight: '215px',
    border: (props) => (!props.isFrontFilled ? '1px solid  #60a5fa66' : '1px solid #ef444466'),
  },
  backLayout: {
    '&': tw`rounded-xl border border-opacity-40
    gap-2 grid grid-cols-2 absolute
    items-start justify-items-center
    z-0  bg-blue-600 bg-opacity-5 border-transparent`,
    minWidth: '388px',
    minHeight: '215px',
    transform: 'translate(50%, -90%)',
    border: (props) => (!props.isBackFilled ? '1px solid  #60a5fa0d' : '1px solid #ef444466'),
  },
  root: {
    border: 'inherit',
    '&': tw`items-center justify-center border border-gray-500 border-opacity-10`,
    '& .MuiFilledInput-root': tw`w-95 bg-transparent`,
    '& .MuiFilledInput-root:hover': tw`bg-transparent`,
    '& .MuiFilledInput-input': tw`p-3`,
    '& .MuiFilledInput-underline:before': tw`border-0`,
    '& .MuiFilledInput-underline:after': tw`border-0`,
    '& .MuiSelect-select:focus': tw`bg-transparent`,
    '& .MuiSvgIcon-root': tw`text-gray-500`,
    '& .MuiInputBase-root': tw`text-current`,
  },
});
